module.exports = __webpack_public_path__ + "static/media/superficieCB.2ef6db38.jpg";